import { createModule } from 'saga-slice';
import { initialState, ChangeLogState, ActivityLog } from './stateType';
import { fetchActivityLogSagaFactory } from './sagas';
const Slice = createModule({
  name: 'changeLog',
  initialState,
  reducers: {
    resetPages: (state: ChangeLogState) => {
      state.page = 0;
      state.activityLog = {
        content: [],
        last: false,
      };
    },
    fetchChangeLog: (state: ChangeLogState) => {
      state.loading = true;
    },
    fetchChangeLogSuccess: (state: ChangeLogState, payload: ActivityLog) => {
      state.loading = false;
      state.page++;
      state.activityLog = state.activityLog = {
        content: [...state.activityLog.content, ...payload.content],
        last: payload.last,
      };
    },
    fetchChangeLogError: (state: ChangeLogState) => {
      state.loading = false;
    },
  },
  sagas: (actions) => ({
    [actions.fetchChangeLog]: fetchActivityLogSagaFactory(actions),
  }),
});

export default Slice;
export const changeLogActions = Slice.actions;
